import React, { useState } from "react";
import { Box, Button, TextField, InputAdornment, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import SquareFootOutlinedIcon from "@mui/icons-material/SquareFootOutlined";
import { useNavigate } from "react-router-dom";

export default function BannerSearch({ type = "all" }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [plotSize, setPlotSize] = useState("");
  const navigate = useNavigate();

  const handleDiscover = () => {
    let queryParams = [];
    if (searchQuery.trim()) queryParams.push(`q=${encodeURIComponent(searchQuery.trim())}`);
    if (plotSize.trim()) queryParams.push(`size=${encodeURIComponent(plotSize.trim())}`);
    queryParams.push(`property_type=${type}`);

    navigate(`/search?${queryParams.join("&")}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleDiscover();
    }
  };

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <Grid container spacing={1.5} alignItems="center">
        {/* Input 1: AREA, CITY OR PLOT NAME */}
        <Grid size={{ xs: 12, sm: 5, md: 5 }}>
          <TextField
            fullWidth
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="AREA, CITY OR PLOT NAME..."
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnOutlinedIcon sx={{ color: "#163F1D", fontSize: "1.2rem" }} />
                </InputAdornment>
              ),
              sx: {
                bgcolor: "#EAF4EC",
                borderRadius: "14px",
                height: 44,
                fontWeight: 700,
                fontSize: "0.82rem",
                color: "#163F1D",
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                "& input": { 
                  color: "#163F1D", 
                  fontWeight: 700,
                  fontSize: "0.82rem",
                },
                "& input::placeholder": {
                  color: "#163F1D",
                  opacity: 0.75,
                  fontWeight: 700,
                  fontSize: "0.78rem",
                  letterSpacing: "0.3px",
                },
              },
            }}
          />
        </Grid>

        {/* Input 2: PLOT SIZE (SQ.FT) */}
        <Grid size={{ xs: 12, sm: 4, md: 4.5 }}>
          <TextField
            fullWidth
            size="small"
            value={plotSize}
            onChange={(e) => setPlotSize(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="PLOT SIZE (SQ.FT)..."
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SquareFootOutlinedIcon sx={{ color: "#163F1D", fontSize: "1.2rem" }} />
                </InputAdornment>
              ),
              sx: {
                bgcolor: "#EAF4EC",
                borderRadius: "14px",
                height: 44,
                fontWeight: 700,
                fontSize: "0.82rem",
                color: "#163F1D",
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                "& input": { 
                  color: "#163F1D", 
                  fontWeight: 700,
                  fontSize: "0.82rem",
                },
                "& input::placeholder": {
                  color: "#163F1D",
                  opacity: 0.75,
                  fontWeight: 700,
                  fontSize: "0.78rem",
                  letterSpacing: "0.3px",
                },
              },
            }}
          />
        </Grid>

        {/* Action Button: Discover */}
        <Grid size={{ xs: 12, sm: 3, md: 2.5 }}>
          <Button
            variant="contained"
            onClick={handleDiscover}
            startIcon={<SearchIcon sx={{ fontSize: "1.2rem" }} />}
            sx={{
              width: "100%",
              height: 44,
              bgcolor: "#163F1D",
              color: "#FFFFFF",
              borderRadius: "14px",
              fontWeight: 800,
              fontSize: "0.9rem",
              textTransform: "none",
              boxShadow: "0 6px 18px rgba(22, 63, 29, 0.25)",
              "&:hover": {
                bgcolor: "#0F2F14",
              },
            }}
          >
            Discover
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
